import '../../sass/pages/_profile100Years.scss';
import Swiper, { Manipulation } from "swiper";
import "swiper/css";
import gsap from "gsap";
import ScrollTrigger, {
  ScrollTriggerAll,
} from "../components/scrollTrigger";
// @ts-ignore
import * as Bouncer from "formbouncerjs";
import { emails } from "../config/constants";
import { apiService } from "../services/api";
import * as sha256 from "crypto-js/sha256";

const api = new apiService();

Swiper.use([Manipulation]);
declare global {
  interface Window {
    drupalSettings: any;
    getUserTapit(): any;
    emaildatalayer: any;
    initSession: any;
    CONFIG_OBJECT_GLOBAL_TAPIT: any;
    dataLayer: any;
    CONFIG_OBJECT_TAPIT: any;
    dataLayerUser(): any;
  }
}

window.addEventListener('load', () => {
	profile100Years()
})

export const profile100Years = async () => {
  validateUser();
  loadCustomClass()
  dataLayerUser();
  loadLateralMenu();
  setPictureInForm();
  loadFormBouncer();
  hideFizBlock();
  getQuestions();

  const { points, ...rest }: any = await api.getUSerTapit();
  const userPoints: any = await api.getUserPoints();
  let userData = { ...rest, ...userPoints }

  setWelcomeMessage(userData).then(() => {
    loadProfileImage(userData.avatar);
    loadAnimation();
  });
};

// IMPRIME LAS PREGUNTAS EN LA PAGINA DE PREMIOS
async function getQuestions() {
  let refQuestionSection = document.querySelector('#questionSection')
  const questions: any = await api.getQuestionsPrizes();
  const markup = ({ id_q, question, points, answers }: any, key: number) => {
    return `
    <div class='sectionpreguntas__container-${id_q} swiper-slide'>
			<div class="ca-question-card">
			  <section class="ca-question-card__header">
				  <span class="ca-question-card__number">Pregunta #${key}</span>
					<h3 class="ca-question-card__title">${question}</h3>
				</section>
				<section class="ca-question-card__body">
				  <select class="ca-question-card__options" name="${id_q}" id="${id_q}">
          <option value="" disabled selected>Seleccione una opción</option>
            ${answers.map((answer: any) => `<option value="${answer}">${answer}</option>`).join(',')}
					</select>
				  <div class="ca-question-card__button">
					  <input class="ca-question-card__submit" id="sendResposeQuestion" type="submit" value="Contestar"/>
						<span>+${points}pts</span>
					</div>
				</section>
			</div>
		</div>`
  }

  if (questions.length > 0 && refQuestionSection) {
    refQuestionSection.innerHTML = ''
    refQuestionSection.insertAdjacentHTML('beforeend', '<section class="sectionpreguntas swiper swiperPreguntas" id="questionSwiper"><article class="swiper-wrapper"></article></section>')
    let swiperQuestion = refQuestionSection.querySelector('#questionSwiper .swiper-wrapper')
    questions.forEach((question: any, index: number) => swiperQuestion.insertAdjacentHTML('beforeend', markup(question, index + 1)))
  }
}

function loadCustomClass() {
  let currentPathName = window.location.pathname
  let bodyContainer = document.querySelector('.ca-profile-container__body')
  if (currentPathName.includes('perfil')) bodyContainer && bodyContainer.classList.add('ca-profile-container__body--profile')
}

function validateUser() {
  document.addEventListener(
    "tapitLoad",
    function (evt: any) {
      if (evt.detail.isLogout) {
        window.initSession();
      }
    },
    false
  );
}

function loadAnimation() {
  setContentAnimation();
  loadQuestionSwiper();
}

// CARGA LA IMAGEN DE USUARIO
function loadProfileImage(source: string) {
  let refBannerImage: HTMLImageElement = document.querySelector(
    ".ca-profile-banner__image"
  );
  let refHeaderImage: HTMLImageElement = document.querySelector(
    ".ca-profile-container__avatar img"
  );
  let refFormImage: HTMLImageElement = document.querySelector(
    "#pictureUser img"
  );

  const updatedImageInForm = () => {
    let refImageInput = document.querySelector(
      "#form_image"
    ) as HTMLInputElement;
    refImageInput &&
      refImageInput.addEventListener("change", (evt) => {
        const [file]: any = refImageInput.files;
        if (file) refFormImage.src = URL.createObjectURL(file);
      });
  };

  updatedImageInForm();

  if (source && source != "la url?") {
    if (refHeaderImage) refHeaderImage.src = source;
    if (refBannerImage) refBannerImage.src = source;
    if (refFormImage) refFormImage.src = source;
  }
  if (refHeaderImage)
    gsap.to(refHeaderImage.parentNode, { duration: 1, opacity: 1 });
}

// ASIGNA LAS ANIMACIONES AL ENCABEZADO
function setHeaderAnimation() {
  const tl = gsap.timeline();

  ScrollTrigger("center", ".ca-profile-container__header", () => {
    tl.to(".ca-profile-container__title", {
      duration: 1,
      opacity: 1,
    });
    tl.to(".ca-points-indicator", {
      duration: 1,
      opacity: 1,
      delay: 0.5,
    });
  });
}

// ASIGNA LAS ANIMACIONES AL CONTENIDO
function setContentAnimation() {
  const tl = gsap.timeline();

  let refTitles =
    ".ca-profile-section__title, .ca-profile-section__subtitle";
  let refDesc = ".ca-profile-section__desc";
  let refSlider = ".swiper-slide";
  let refBanner = ".ca-profile-banner, .ca-top-banner, .ca-without-questions";
  let refForm = `#co-aguila-100-years-profile-form`;

  gsap.set(`${refSlider}`, {
    opacity: 0,
    translateX: 20,
  });
  gsap.set(`${refForm}`, {
    opacity: 0,
  });

  // Show Titles and Text
  ScrollTriggerAll(
    "center",
    `${refTitles}, ${refDesc}`,
    (currentTarget) => {
      gsap.to(currentTarget, {
        duration: 1,
        opacity: 1,
        translateX: 0,
      });
    }
  );

  // Show Banners
  ScrollTriggerAll("center", `${refBanner}`, (currentTarget) => {
    gsap.to(currentTarget, {
      duration: 1,
      opacity: 1,
      translateX: 0,
    });
  });

  // Show Sliders
  ScrollTriggerAll("center", `#questionSwiper`, () => {
    gsap.to(`${refSlider}`, {
      duration: 1.5,
      opacity: 1,
      translateX: 0,
      stagger: 0.3,
    });
  });

   // Show Buttons
   ScrollTriggerAll("top", `#profileBtns`, (currentTarget) => {
    gsap.to(currentTarget, {
      duration: 1,
      opacity: 1,
    });
  });

  // Show Form Fields
  ScrollTriggerAll("top", `${refForm}`, () => {
    gsap.to(`${refForm}`, {
      duration: 1.5,
      opacity: 1,
      translateX: 0,
    });
    gsap.to('.ca-profile-butterfly', {
      duration: 1,
      opacity: 1,
      stagger: 0.2
    });
  });

  // Show Title/Text Bottom Banner
  ScrollTriggerAll("top", ".ca-bottom-banner--hidden", (currentTarget) => {
    gsap.to(currentTarget, {
      duration: 1,
      opacity: 1
    }).then(() => {
      // Show Title/Text Bottom Banner
      ScrollTriggerAll("center", ".ca-bottom-banner--hidden .ca-bottom-banner__title, .ca-bottom-banner--hidden .ca-bottom-banner__desc", (currentTarget) => {
        gsap.to(currentTarget, {
          duration: 1.5,
          opacity: 1,
          translateX: 0,
          translateY: 0,
          ease: "back.out(2)"
        });
      });

      // Show Prizes Bottom Banner
      ScrollTriggerAll("center", ".ca-bottom-banner--hidden .ca-bottom-banner__prizes", () => {
        gsap.to('.ca-bottom-banner--hidden .ca-bottom-banner__prizes-item', {
          duration: 1,
          opacity: 1,
          translateX: 0,
          stagger: .5
        });
      });

      // Show Button Bottom Banner
      ScrollTriggerAll("center", ".ca-bottom-banner--hidden .ca-bottom-banner__button", (currentTarget) => {
        gsap.to(currentTarget, {
          duration: 1,
          opacity: 1,
        });
      });
    })
  });
}

// CARGA EL SLIDER DE LAS PREGUNTAS
function loadQuestionSwiper() {
  const loadPoints = async (earnedPoints: number) => {
    let refPoints: HTMLElement = document.querySelector("#userPoints");
    let nwPoints: number;
    if (refPoints) {
      nwPoints = parseInt(refPoints.innerHTML) + earnedPoints
      refPoints.innerHTML = `${nwPoints}`;
    }
  }

  const swiper = new Swiper("#questionSwiper", {
    spaceBetween: 20,
    breakpoints: {
      360: {
        slidesPerView: "auto",
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 30,
      },
    },
    on: {
      click: async (swip: any, event: any) => {
        let currentTarget = event.target as HTMLElement;
        if (currentTarget.classList.contains("ca-question-card__submit")) {
          let parentSlide = currentTarget.closest(".swiper-slide");
          let select: HTMLInputElement = parentSlide?.querySelector('.ca-question-card__options') as HTMLInputElement
          if (select.value != '') {
            console.log('ANTES DE GUARDAR PREGUNTA', { questionId: select.id, optionId: select.value });
            const result: any = await api.sendQuestionAnswer({ questionId: select.id, optionId: select.value });
            console.log('DESPUES DE GUARDAR LA PREGUNTA', result);
            
            if (result) {
              loadPoints(result.points)
              gsap
                .to(parentSlide, { duration: 1, opacity: 0 })
                .then(() => {
                  // @ts-ignore
                  swiper.removeSlide(swip.clickedIndex);
                });
            }
          }
        }
      },
    },
  });
}

// CARGA LA FUNCIONALIDAD DEL MENU LATERAL
function loadLateralMenu() {
  let listLinks = document.querySelectorAll(
    ".ca-profile-container__lateral-menu ul a"
  ) as any;
  let currentLink = window.location.pathname;
  let activeLink: HTMLLinkElement;

  let refDropdownButton = document.querySelector(
    ".ca-profile-container__dropdown-menu"
  );
  let refListMenu = document.querySelector(
    ".ca-profile-container__lateral-menu ul"
  );

  // GET CURRENT LINK
  if (listLinks)
    activeLink = [...listLinks].find(
      (link) => link.getAttribute("href") == currentLink
    );

  // SET CURRENT LINK AND SECTION IN BUTTON
  if (activeLink) {
    activeLink.classList.add("active");
    refDropdownButton.innerHTML = activeLink.innerHTML;
  }

  // ENABLE OR DISABLE DROPDOWN
  refDropdownButton &&
    refDropdownButton.addEventListener("click", (e) => {
      let currentTarget = e.target as HTMLElement;
      currentTarget.classList.toggle("active");
      refListMenu && refListMenu.classList.toggle("active");
    });
}

// OCULTA EL BLOQUE FIZBLOCK
function hideFizBlock() {
  window.onload = () => {
    let refElm = document.querySelector("#block-fizbtnsound");
    refElm && refElm.remove();
  };
}

// AGREGA LAS VALIDACIONES AL FORMULARIO
function loadFormBouncer() {
  var validateFormBouncer = Bouncer(
    "#co-aguila-100-years-profile-form",
    {
      patterns: {
        email: /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
      },
      customValidations: {
        emailVerified: function (field: any) {
          let array_email = field.value.split("@");
          const res = emails.find((m) => m === array_email[1]);
          const validateBack = document.querySelector(
            ".field-suffix .error-message"
          );
          if (validateBack) validateBack.classList.add("hidden");
          // console.log(field)
          return res === undefined ? false : true;
        },
        onlyLetter: (field: any) => {
          if (field.name == "name" || field.name == "lastname") {
            const value = field.value;
            const pattern = new RegExp(
              "^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+$",
              "i"
            );
            // console.log(pattern.test(value))
            if (!pattern.test(value)) return true;
          }
        },
        onlyNumber: (field: any) => {
          if (
            field.name == "cellphone" ||
            field.name == "numberdocumentid" ||
            field.name == "confnumberdocumentid"
          ) {
            const value = field.value;
            const pattern = new RegExp("^[0-9]+$", "i");
            if (!pattern.test(value)) return true;
          }
        },
        phoneVerified: function (field: any) {
          if (field.name == "cellphone") {
            const value = field.value;
            if (value.length < 10) {
              return true;
            }
          }
        },
        idVerified: function (field: any) {
          if (field.name == "numberdocumentid") {
            const value = field.value;
            if (value.length < 8) {
              return true;
            }
          }
        },
        password: function (field: any) {
          if (field.name === "passconfirm[pass2]") {
            let contraseña = document.getElementById(
              "edit-passconfirm-pass1--2"
            ) as any;
            if (field.value != contraseña.value) {
              return false;
            }
            return true;
          }
        },
        ageVerified: function (field: any) {
          if (field.name === "birthdate_day") {
            let year = document.getElementById(
              "edit-birthdate-year"
            ) as any;
            let month = document.getElementById(
              "edit-birthdate-month"
            ) as any;
            let day = document.getElementById(
              "edit-birthdate-day"
            ) as any;
            year = year.value;
            month = month.value;
            day = day.value;
            const response = getAge(year, month, day);
            if (response < 18) {
              // console.log(response)
              document
                .getElementById("edit-birthdate-day")
                .classList.add("error-edad");
              return true;
            }
            return false;
          }
        },
      },
      messages: {
        missingValue: {
          checkbox:
            "Debe aceptar Términos y condiciones y Políticas de privacidad",
          default: "Campo obligatorio",
        },
        onlyNumber: "Sólo se permiten números",
        onlyLetter: "Sólo se permiten letras",
        phoneVerified: "Sólo se permiten 7 a 10 dígitos",
        idVerified: "Sólo se permiten 7 a 10 dígitos",
        ageVerified: "Debe ser mayor de edad",
        password: "Contraseñas no coincide",
        emailVerified: "Por favor ingrese un email válido",
        patternMismatch: {
          email: "Por favor ingrese un email válido",
        },
      },
    }
  ) as any;

  function getAge(y: any, m: any, d: any) {
    var today = new Date();
    var birthDate = new Date(`${y}/${m}/${d}`);
    var age = (today.getFullYear() - birthDate.getFullYear()) as any;
    var m = (today.getMonth() - birthDate.getMonth()) as any;
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}

// ACTUALIZA LOS DATOS DEL ENCABEZADO POR LOS DEL USUARIO
function setWelcomeMessage(userTapit: any): Promise<any> {
  let refWelcomeMessage: HTMLElement = document.querySelector(
    ".ca-profile-container__title"
  );
  let refPoints: HTMLElement = document.querySelector("#userPoints");

  return new Promise<string>((resolve, reject) => {
    if (userTapit.firstName) {
      let firstName =
        userTapit.firstName && userTapit.firstName.split(" ")[0];
      let message =
        userTapit.gender == "male"
          ? `Bienvenido, ${firstName}`
          : userTapit.gender == "female"
            ? `Bienvenida, ${firstName}`
            : `Hola, ${firstName}`;
      if (refWelcomeMessage) refWelcomeMessage.innerHTML = message;
      if (refPoints) refPoints.innerHTML = userTapit.points;
      setHeaderAnimation();
      return setTimeout(
        () => resolve("Agregando datos del usuario"),
        1000
      );
    }
    reject("No se encontraron datos del usuario");
  });
}

// AGREGA UN CONTROLADOR AL LABEL DE SUBIR IMAGEN
function setPictureInForm() {
  let refPicture = document.querySelector("#pictureUser");
  let refForm: HTMLLabelElement = document.querySelector(
    "#profileForm .form-item-files-avatar label"
  );
  let refFileInput: HTMLInputElement = document.querySelector(
    "#profileForm .form-item-files-avatar input"
  );

  if (refForm) {
    refForm.insertAdjacentElement("afterbegin", refPicture);
    refForm.addEventListener("click", () => refFileInput.click());
  }
}

function dataLayerUser() {
  // el datalayer de registro/login esta en el twig del page
}
